import { format }  from 'd3-format';

export function tformat(y) {
    return (format(",.0d")(-y) + " AC").replace(",",".");
  }

export function formatYear(y) {
    if (y > 0 )
      return y + " AD"
    else  if (y === 0)
      return "0 AD";
    else
      return tformat(y)
  }


export function formatAxisYear (y) {
    if (y > 0 )
      return y + " AD";
    else  if (y === 0)
      return "0 AD";
    else  if (y >= 2200)
      return "";
    else if (y >= -10000 )
      return (-y) + " AC";
    else if (y >= -20000 )
      if (y % 2000 === 0)
        return tformat(y)
      else
        return ""
    else if (y >= -100000 )
      if (y % 10000 === 0)
        return tformat(y)
      else
        return ""
    else if (y >= -200000 )
      if (y % 20000 === 0)
        return tformat(y)
      else
        return ""
    else if (y >= -300000 )
      if (y % 50000 === 0)
        return tformat(y)
      else
        return ""
    else
      return ""
  }

  export function formatAxisYearSmaller (y) {
      if (y > 0 )
        return y + " AD";
      else  if (y === 0)
        return "0 AD";
      else  if (y >= 2200)
        return "";
      else if (y >= -1000 )
          return (-y) + " AC";
      else if (y >= -5000 )
        if (y % 1000 === 0)
          return tformat(y)
        else
          return ""
      else if (y >= -10000 )
        if (y % 5000 === 0)
          return tformat(y)
        else
          return ""
      else if (y >= -100000 )
        if (y % 10000 === 0)
          return tformat(y)
        else
          return ""
      else if (y >= -200000 )
        if (y % 20000 === 0)
          return tformat(y)
        else
          return ""
      else if (y >= -300000 )
        if (y % 50000 === 0)
          return tformat(y)
        else
          return ""
      else
        return ""
    }
